import Marquee from "react-fast-marquee";
import { PARTNERS } from "../data/content";

const LogoCard = ({ partner }) => (
  <div
    data-testid={`partner-${partner.name.toLowerCase().replace(/\s+/g, "-")}`}
    className={`group mx-4 flex h-24 w-52 shrink-0 items-center justify-center overflow-hidden rounded-[20px] shadow-[0_8px_30px_rgba(0,0,0,0.04)] transition-transform duration-300 hover:-translate-y-1 ${
      partner.logo ? "bg-white" : "border border-border bg-white"
    }`}
  >
    {partner.logo ? (
      <img
        src={partner.logo}
        alt={partner.name}
        className="h-full w-full object-cover transition-transform duration-500 group-hover:scale-105"
      />
    ) : (
      <span className="font-display text-2xl font-bold tracking-tight text-charcoal/30 grayscale transition-all duration-500 group-hover:text-forest group-hover:grayscale-0">
        {partner.name}
      </span>
    )}
  </div>
);

export const PartnersMarquee = () => {
  return (
    <div className="space-y-6">
      <Marquee gradient={false} speed={38} pauseOnHover>
        {PARTNERS.map((p) => (
          <LogoCard key={`top-${p.name}`} partner={p} />
        ))}
      </Marquee>
      <Marquee gradient={false} speed={38} direction="right" pauseOnHover>
        {[...PARTNERS].reverse().map((p) => (
          <LogoCard key={`bottom-${p.name}`} partner={p} />
        ))}
      </Marquee>
    </div>
  );
};
